module.exports = __webpack_public_path__ + "media/images/area/feature/kansai/related/zh-hans/6-bcdf7e482390d1ab676d30d9fe9626f1.jpg";